export enum EnumEmployeeRole {
  BASIC = "BASIC",
  HR = "HR",
}

export enum HR {
  "HR" = "HR",
}
